import React from "react";
import { FaPlay, FaStop } from "react-icons/fa";
import 'animate.css';

import TimelineItem from "./TimelineItem";

/**
 * 
 * @param {left} props bool signifies left alignment
 * @param {items} prop list of items to be displayed
 * 
 * @returns gui
 */
const Timeline = ({left, elv, items, opaque}) => {

    return (
        <div className={`
                ${left? "tline-container-left ": "tline-container "} animate__animated animate__backInDown 
                ${new Date(elv.x_belbeg) > new Date() || new Date(elv.x_datum_vertragsende) < new Date()? "full-future": new Date(elv.x_datum_vertragsende) > new Date()? "future": ""}
            `}
        >
            <div className={left? 'tline-container-icon-end-left': 'tline-container-icon-end'}>
                <FaStop size={40} style={new Date(elv.x_belbeg) > new Date()? {opacity:"0.3"} : null}  />
            </div>
            <TimelineItem key={`elvend-${elv.id}`} left={left} type="elvend" future={new Date(elv.x_datum_vertragsende) > new Date() || new Date(elv.x_datum_vertragsende) < new Date()} data={elv} endinvoice={items.filter(i => i.x_energieliefervertrag_id !== undefined && i.x_energieliefervertrag_id[0] === elv.id && i.x_is_final_invoice === true)} />
            {items.map(item => (
                (item.x_energieliefervertrag_id !== undefined && item.x_energieliefervertrag_id[0] === elv.id) ||
                (item.x_elv_ako_id !== undefined && item.x_elv_ako_id !== "False" && item.x_elv_ako_id[0] === elv.id) ||
                (item.x_elv_abr_id !== undefined && item.x_elv_abr_id !== "False" && item.x_elv_abr_id[0] === elv.id) ||
                (item.x_elv_grundversorgung_id !== undefined && item.x_elv_grundversorgung_id !== "False" && item.x_elv_grundversorgung_id[0] === elv.id) ?
                    item.x_file_stornorechnung_name !== undefined && item.x_file_stornorechnung_name !== "False"?
                        <TimelineItem key={`storno-${item.id}`} type="storno" data={item} left={left} future={opaque} /> :
                    item.x_file_mahnung_name !== undefined && item.x_file_mahnung_name !== "False"?
                        <TimelineItem key={`mahnung-${item.id}`} type="mahnung" data={item} left={left} future={opaque} /> :
                    item.x_file_poolrechnung_name !== undefined ?
                        <TimelineItem key={`pool-${item.id}`} type="poolrechnung" data={item} left={left} future={opaque}/> :
                    item.x_file_abrechnung_name !== undefined && item.x_is_final_invoice === false ?
                        <TimelineItem key={`abr-${item.id}`} type="abrechnung" data={item} left={left} future={opaque} /> :
                    item.x_file_vorschreibung_name !== undefined ?
                        <TimelineItem key={`vor-${item.id}`} type="vorschreibung" data={item} left={left} future={opaque} /> :
                    null
                :null
            ))}

            <TimelineItem key={`elvstart-${elv.id}`} type="elvstart" left={left} data={elv} future={new Date(elv.x_belbeg) > new Date() || new Date(elv.x_datum_vertragsende) < new Date() }/>

            <div className={left? 'tline-container-icon-start-left':'tline-container-icon-start'}>
                <FaPlay size={40} style={new Date(elv.x_belbeg) > new Date() || new Date(elv.x_datum_vertragsende) < new Date() ? {opacity:"0.3"} : null} />
            </div>
        </div>
    )
} 

export default Timeline;